import { useMutation } from "@apollo/client";
import { DELETE_COMPANY_DOCUMENTS } from "../api/delete-company-documents";
import { useNotification } from "@/shared/feedback/notification";
import { useDocumentsTranslations } from "@/modules/documents/shared/utils/use-documents-translations";
import { FIND_COMPANY_DOCUMENTS } from "@/modules/documents/widgets/company-documents-list";
import { GET_COMPANY_DOCUMENT_TREE } from "@/modules/documents/widgets/company-document-tree";

export function useDeleteCompanyDocumentsMutation() {
  const t = useDocumentsTranslations();
  const notify = useNotification();
  const [deleteCompanyDocuments, { loading }] = useMutation(
    DELETE_COMPANY_DOCUMENTS,
    {
      refetchQueries: [FIND_COMPANY_DOCUMENTS, GET_COMPANY_DOCUMENT_TREE],
    },
  );

  const remove = async (id: string) => {
    const response = await deleteCompanyDocuments({
      variables: {
        id,
      },
    });

    if (response.data?.deleteCompanyDocument) {
      notify?.success({
        message: t("Company document delete successfully"),
      });
    }
  };

  return {
    remove,
    loading,
  };
}
